<template>
  <ks-map
      v-if="isActive"
      ref="map"
      :apiKey="map.apiKey"
      @click="mapEvents($event, 'click')"
      @zoom="mapEvents($event, 'zoom')"
      @dragend="mapEvents($event, 'dragend')"
      @onLoad="mapEvents($event, 'onLoad')"
      @markerClick="mapEvents($event, 'markerClick')"
      style="height:500px"
      :markers="markers"
      :data_provider="dataProvider"
      :readFilters="readFilters"
      :clickRecordFields="clickRecordFields"
  />
</template>
<!--TODO: pass in the readFilters and clickRecordFields-->

<script>
//import routes from "../../../pages/context";

export default {
  name:     "ks-list-map",
  computed: {
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    },
    list() {
      return this.$parent.list;
    },
    activeViewType() {
      return this.$parent.activeViewType;
    },
    isActive() {
      return this.$parent.activeViewType == 'map';
    }
  },
  watch:    {
    list:     {
      handler() {
        this.loadMapData();
      },
      depp: true
    },
    isActive: function (val) {
      if (val) this.$parent.activeViewComponent = this;
    }
  },
  mounted() {
    if (this.isActive) {
      this.$parent.activeViewComponent = this;
    }
    this.loadMapData();
  },
  methods: {
    getComponentConfiguration() {
      return {'activeViewType': this.activeViewType};
    },
    setComponentConfiguration(config) {
      //TODO if there is any config to set for this component on mode load, do it here.
    },
    loadMapData() {
      try {
        this.markers = [];
        let icons    = typeof this.l_map.icons !== 'undefined' && this.l_map.icons !== {} ? this.l_map.icons : undefined;
        if (this.l_map.apiKey) {
          if (this.l_map.lat && this.l_map.lng) {
            for (let row of this.list) {
              if (row[this.l_map.lat] && row[this.l_map.lng]) {
                let icon = icons && this.l_map.icon ? (typeof row[this.l_map.icon] !== 'undefined' ? typeof icons[row[this.l_map.icon]] !== 'undefined' : icons[this.l_map.icon]) : undefined;
                this.markers.push({
                  title:       this.l_map.title && row[this.l_map.title] ? row[this.l_map.title] : null,
                  lat:         row[this.l_map.lat],
                  lng:         row[this.l_map.lng],
                  click:       row[this.l_map.click] ? row[this.l_map.click] : null,
                  campaign_id: row.campaign_id,
                  id:          row.id,
                  icon:        icon
                })
              }
            }
            if (this.createRoute && this.markers.length > 1) {
              this.createRoute();
            }
          } else if (this.l_map.defaultMarkers && this.l_map.defaultMarkers.length > 0) {
            this.markers = this.l_map.defaultMarkers;
          }
        }
      } catch (err) {
        console.log('KS-APP: ', err);
      }
    },
    createRoute() {

      let callData = {
        "origin":                   {},
        "destination":              {},
        "intermediates":            [],
        "travelMode":               "DRIVE",
        "optimizeWaypointOrder":    "true",
        "routingPreference":        "TRAFFIC_AWARE",
        "computeAlternativeRoutes": false,
        "routeModifiers":           {
          "avoidTolls":    false,
          "avoidHighways": false,
          "avoidFerries":  false
        },
        "languageCode":             "en-US",
        "units":                    "IMPERIAL"
      }
      this.markers.forEach((marker, index) => {
        if (index === 0) {
          callData.origin = {
            "location": {
              "latLng": {
                "latitude":  marker.lat,
                "longitude": marker.lng
              }
            }
          }
        } else if (index < this.markers.length - 1) {
          callData.intermediates.push(
              {
                "location": {
                  "latLng": {
                    "latitude":  marker.lat,
                    "longitude": marker.lng
                  }
                }
              }
          )
        } else if (index === this.markers.length - 1) {
          callData.destination = {
            "location": {
              "latLng": {
                "latitude":  marker.lat,
                "longitude": marker.lng
              }
            }
          }
        }
      })
      console.log("callData", callData);

      /*const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Goog-Api-Key': this.map.apiKey, 'X-Goog-FieldMask': routes.duration,routes.distanceMeters,routes.polyline.encodedPolyline },

        body: JSON.stringify(callData)
      };
      fetch('https://routes.googleapis.com/directions/v2:computeRoutes', requestOptions)
          .then(response => response.json())
          .then(data => {
            console.log("data", data);
          });*/

    },
    mapEvents(event, name) {
      switch (name) {
        case 'onLoad':
          if (this.l_map.searchOnDragControl) {
            let controlUI                   = document.createElement("div");
            controlUI.style.backgroundColor = "#fff";
            controlUI.style.border          = "2px solid #fff";
            controlUI.style.borderRadius    = "3px";
            controlUI.style.boxShadow       = "0 2px 6px rgba(0,0,0,.3)";
            controlUI.style.cursor          = "pointer";
            controlUI.style.margin          = "10px";
            controlUI.style.textAlign       = "center";
            controlUI.title                 = "search on drag map";

            let checkContainer       = document.createElement("label");
            checkContainer.className = "map-searchondrag-label";
            let checkInput           = document.createElement("input");
            checkInput.type          = "checkbox";
            checkInput.className     = "map-searchondrag-checbox-control"
            checkInput.setAttribute("id", `checkSearchOnDrag_${this._uid}`);
            checkInput.setAttribute("checked", this.searchOnDrag);

            checkInput.addEventListener('change', (e) => {
              this.searchOnDrag = e.target.checked;
            }, false);

            let checkLabel       = document.createElement("label");
            checkLabel.className = "map-searchondrag-checbox-label"
            checkLabel.setAttribute("for", `checkSearchOnDrag_${this._uid}`);
            checkLabel.innerHTML = "Search on Drag";
            checkContainer.appendChild(checkInput);
            checkContainer.appendChild(checkLabel);
            controlUI.appendChild(checkContainer);
            event.l_map.controls[google.maps.ControlPosition.TOP_LEFT].push(controlUI);
          }
          break;
        default:
          break;
      }
      this.$emit('mapEvent', {event: event, name: name, enableSearchOnDrag: this.searchOnDrag});
    }
  },
  props:   {
    readFilters:       {
      type: Object, default: () => {
      }
    },
    clickRecordFields: {
      type: Array, default: () => []
    },
    map:               {
      type:     Object,
      required: true
    },
    draggable:         {
      type:    Boolean,
      default: false
    },
    createRoute:       {
      type:    Boolean,
      default: false
    }
  },
  data() {
    return {
      markers:      [],
      l_map:        this.map,
      searchOnDrag: true,
    }
  }
}
</script>
